import React, { Fragment, useEffect, useState } from 'react';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import ScannerIcon from "@material-ui/icons/Scanner";

import {
    useStylesUp, useStylesHed, useStylesAuto, useStylesAutoPurch, useStylesTF, useStylesTD, useStylesBA, useStylesLbl
    , useStylesUiElemment,
    useStylesSpDial,
} from '../../../../St/Reports/UseStyle';
import { AppBar, Button, ButtonGroup, colors, Container, CssBaseline, Hidden, Paper, Toolbar, Typography } from '@material-ui/core';
import { useTranslation } from "react-i18next";
import KeyboardReturnSharpIcon from "@material-ui/icons/KeyboardReturnSharp";
import DeleteIcon from '@material-ui/icons/Delete';
import SearchIcon from '@material-ui/icons/Search';
import SaveIcon from '@material-ui/icons/Save';
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import CircularProgress from "@material-ui/core/CircularProgress";
import { insh } from "../../../../Context/InshSt";
import PrintIcon from "@material-ui/icons/Print";
import TransformIcon from "@material-ui/icons/Transform";
import Tab from "@material-ui/core/Tab";
import Fab from "@material-ui/core/Fab";
import Tooltip from "@material-ui/core/Tooltip";
import CheckIcon from "@material-ui/icons/Check";
import {
    ArrowBackIos,
    ArrowDownward,
    ArrowForwardIos,
    Delete,
    FirstPage,
    LastPage,
    MoreVert,
    PersonAddRounded,
    Reply,
    RestaurantMenu,
    Update,
} from "@material-ui/icons";
import Switch from "@material-ui/core/Switch";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import PostAddIcon from "@material-ui/icons/PostAdd";
import AddBoxIcon from "@material-ui/icons/AddBox";
import StopIcon from "@material-ui/icons/Stop";
import PagenationButtons from '../../../../components/controls/PagenationButons';
import i18next from "i18next";
import ButtonsSearch from '../../../Accounts/BackEnd/receipt-voucher/components/ButtonsSearch';
import PrintingButtons from '../../../../components/controls/PrintingButtons';

export default function MainInvoiceAppar(props) {
    const { t } = useTranslation(["forms", "translation"]);

    const {
        buttonClassnameSave,
        buttonClassnameDelete,
        clasCAB,
        setting,
        loading,
        backHome,
        uiElement,
        success,
        handOpenDw,
        clickOpenToggle,
        isHedden,
        permistionInv,
        style,
        stElemnt,
        clasBA,
        switchState,
        handCOpenCu,
        TransitionUp,
        toWhere,
        toPrint,
        transForm,
        buttonClassnamePrint,
        elmntBtn,
        or,
        stor,
        setPdfToggle,
        generating,
        StyledMenuItem,
        deleteTos,
        transformDone,
        transformDonePurch,
        setConfirmDialog,
        pdfToggle,
        StyledMenu,
        handOpenDwt,
        handNewInv,
        HomeBcode,
        TransitionDown,
        styBtn,
        clickCloseToggle,
        toggle,
        clickOpenTogglePrint,
        isDialog,
        isKham,
        idata,
        AutoOptions,
        sendToZatca,
        isOpenUpdate,
        setIsOpenUpdate,
        onClickButton,
        procIdSearch,
        openButtonsSearch,
        setOpenButtonsSearch,
        isLoading,
        toPrintTemplate,

    } = props;
    const clasup = useStylesUp();
    const [styles, setStyles] = useState(insh.bascData);
    const [mouseInterA, setMouseInterA] = useState(false);
    const [mouseInterB, setMouseInterB] = useState(false);
    const [mouseInterC, setMouseInterC] = useState(false);
    const [mouseInterD, setMouseInterD] = useState(false);

    let isSave = isKham != 1 && stor.invsType === 8 ? false : permistionInv?.ISSAVE == null ? true : permistionInv?.ISSAVE;


    const calsPurch = useStylesAutoPurch();
    const claslbl = useStylesLbl();
    const clasAo = useStylesAuto();
    const clasTF = useStylesTF();
    const clickUpdate = () => {
        setIsOpenUpdate(true);
    };
 
    return (
        <React.Fragment >
            <CssBaseline />
            <AppBar
                position="fixed"
                color="primary"
                style={{ ...style.bgImg, ...stElemnt.all.appBarBA }}
            >
                <Toolbar className={clasBA.ToolbarBA} variant="dense">
                    <Hidden smUp={["sm"]}>
                        {isDialog == true ? (
                            <IconButton
                                edge="start"
                                color="inherit"
                                aria-label="backH"
                                onClick={props.onClose}
                            >
                                <CloseIcon />
                            </IconButton>) :
                            (
                                <dinv>
                                    <IconButton
                                        edge="start"
                                        color="inherit"
                                        aria-label="backH"
                                        onClick={backHome}
                                    >
                                        <CloseIcon />
                                    </IconButton>

                                    {/* <IconButton
                                        edge="start"
                                        color="inherit"
                                        aria-label="searsh"
                                        disabled={!permistionInv.Se}
                                        onClick={() => handOpenDwt(TransitionDown)}
                                    >
                                        <StopIcon />
                                    </IconButton> */}
                                    {/* <IconButton
                                        edge="start"
                                        color="inherit"
                                        aria-label="searsh"
                                        disabled={!permistionInv.Se}
                                        onClick={() => handOpenDw(TransitionDown)}
                                    >
                                        <SearchIcon />
                                    </IconButton> */}

                                    <IconButton
                                        edge="start"
                                        color="inherit"
                                        disabled={!permistionInv.Ne}
                                        aria-label="handNew"
                                        onClick={handNewInv}
                                    >
                                        <AddBoxIcon />
                                    </IconButton>
                                </dinv>)}

                    </Hidden>

                    <Hidden only={["xs"]}>
                        {isDialog === true ? (
                            <Button
                                style={styBtn.undis}
                                startIcon={<CloseIcon />}
                                onClick={props.onClose}
                            >

                                {transForm("exit")}
                            </Button>
                        ) : (
                            <div>
                                <Button
                                    style={styBtn.undis}
                                    onClick={backHome}
                                    startIcon={<CloseIcon />}
                                >
                                    {transForm("exit")}
                                </Button>

                                {/* <Button
                                    style={!permistionInv.Se ? styBtn.dis : styBtn.undis}
                                    disabled={!permistionInv.Se}
                                    onClick={() => handOpenDwt(TransitionDown)}
                                    startIcon={<StopIcon />}
                                >
                                    {transForm("out-billing")}
                                </Button>

                                <Button
                                    style={!permistionInv.Se ? styBtn.dis : styBtn.undis}
                                    disabled={!permistionInv.Se}
                                    onClick={() => handOpenDw(TransitionDown)}
                                    startIcon={<SearchIcon />}
                                >
                                    {transForm("invoice-search")}
                                </Button> */}


                                <Button
                                    style={!permistionInv.Ne ? styBtn.dis : styBtn.undis}
                                    disabled={!permistionInv.Ne}
                                    onClick={handNewInv}
                                    startIcon={<AddBoxIcon />}
                                >
                                    {transForm("new")}
                                </Button>
                            </div>)}
                    </Hidden>

                    {!isHedden
                        ?
                        switchState.tableOrscanBC ?
                            (
                                <Fab
                                    color="primary"
                                    aria-label="add"
                                    style={{
                                        ...style.fabButtonBA,
                                        ...stElemnt.all.fabButtonBA,
                                        ...{ height: 0, width: 0 },
                                    }}
                                    onClick={() => handCOpenCu(TransitionUp)}
                                >
                                    <HomeBcode />{" "}
                                </Fab>
                            ) :
                            (
                                <Fab
                                    color="primary"
                                    aria-label="add"
                                    style={{ ...style.fabButtonBA, ...stElemnt.all.fabButtonBA }}
                                    onClick={() => handCOpenCu(TransitionUp)}
                                >
                                    <PostAddIcon />{" "}
                                </Fab>
                            )
                        :
                        false
                    }

                    {!props.isDialog && (
                        <Hidden only={["xs"]}>
                            <ButtonsSearch
                                {...{
                                    onClickButton, openButtonsSearch, procIdSearch, setOpenButtonsSearch
                                }}
                            />
                        </Hidden>
                    )}

                    <div className={clasBA.growBA} />

                    <StyledMenu
                        id="customized-menu"
                        anchorEl={pdfToggle}
                        keepMounted
                        open={Boolean(pdfToggle)}
                        onClose={() => setPdfToggle(null)}
                        style={stElemnt.itemHigh}
                    >
                        {
                            (idata?.ProcType_InvProc == "02" || idata?.ProcType_InvProc == "12") &&
                            !idata?.IsReportedToZatca &&
                            AutoOptions?.StepTwo?.id === 1 &&
                            <div className={clasCAB.wrapperCAB}>
                                <StyledMenuItem
                                    disabled={isLoading ? true : loading.print || loading.save || generating}
                                    className={buttonClassnamePrint}
                                    onClick={() => sendToZatca("save")}
                                >
                                    <ListItemText primary={transForm("Submit To Zatca ")} />
                                </StyledMenuItem>
                                {(loading.print || loading.save || generating) && (
                                    <CircularProgress
                                        size={24}
                                        className={clasCAB.buttonProgressCAB}
                                    />
                                )}
                            </div>
                        }
                        <div className={clasCAB.wrapperCAB}>
                            <StyledMenuItem
                                disabled={isLoading ? true :
                                    or.postput == "toPost"
                                        ? isSave === false ? true : false
                                        : loading.print || loading.save || generating
                                }
                                //  disabled={loading.print || loading.save || generating}
                                className={buttonClassnamePrint}
                                onClick={() => toPrint("print", "e", 3)}
                            >
                                <ListItemIcon>
                                    <PrintIcon fontSize="small" />
                                </ListItemIcon>
                                <ListItemText primary={transForm("مباشر ")} />
                            </StyledMenuItem>
                            {(loading.print || loading.save || generating) && (
                                <CircularProgress
                                    size={24}
                                    className={clasCAB.buttonProgressCAB}
                                />
                            )}
                        </div>
                        <div className={clasCAB.wrapperCAB}>
                            <StyledMenuItem
                                disabled={isLoading ? true :
                                    or.postput == "toPost"
                                        ? isSave === false ? true : false
                                        : loading.print || loading.save || generating
                                }
                                className={buttonClassnamePrint}
                                onClick={() => toPrint("print", "e", 4)}
                            >
                                <ListItemIcon>
                                    <ScannerIcon fontSize="small" />
                                </ListItemIcon>
                                <ListItemText primary={transForm("طباعة كبير")} />
                            </StyledMenuItem>
                            {(loading.print || loading.save || generating) && (
                                <CircularProgress
                                    size={24}
                                    className={clasCAB.buttonProgressCAB}
                                />
                            )}
                        </div>
                    </StyledMenu>

                    <StyledMenu
                        id="customized-menu"
                        anchorEl={toggle}
                        keepMounted
                        open={Boolean(toggle)}
                        onClose={clickCloseToggle}


                        style={stElemnt.itemHigh}
                    >
                        <div className={clasCAB.wrapperCAB}>
                            <StyledMenuItem
                                disabled={isLoading ? true :
                                    or.postput == "toPost"
                                        ? isSave === false ? true : false
                                        : loading.print || loading.save
                                }

                                // disabled={loading.print || loading.save}
                                className={buttonClassnamePrint}
                                onClick={() => toPrint("print", "e", 1)}
                            >
                                <ListItemIcon>
                                    <PrintIcon fontSize="small" />
                                </ListItemIcon>
                                <ListItemText primary={transForm("cashier-view")} />
                            </StyledMenuItem>
                            {(loading.print || loading.save) && (
                                <CircularProgress
                                    size={24}
                                    className={clasCAB.buttonProgressCAB}
                                />
                            )}
                        </div>

                        <div className={clasCAB.wrapperCAB}>
                            <StyledMenuItem
                                disabled={isLoading ? true :
                                    or.postput == "toPost"
                                        ? isSave === false ? true : false
                                        : loading.print || loading.save
                                }
                               
                                className={buttonClassnamePrint}
                                onClick={() => toPrint("print", "e", 2)}
                            >
                                <ListItemIcon>
                                    <ScannerIcon fontSize="small" />
                                </ListItemIcon>
                                <ListItemText primary={transForm("great-view")} />
                            </StyledMenuItem>
                            {(loading.print || loading.save) && (
                                <CircularProgress
                                    size={24}
                                    className={clasCAB.buttonProgressCAB}
                                />
                            )}
                        </div>
                    </StyledMenu>
                    <Hidden smDown={["sm"]}>
                    <PrintingButtons color={"#fff"} disabled={isLoading} onClick={toPrintTemplate} />
                    </Hidden>

                    <Hidden smUp={["sm"]}>
                        {
                            stor.invsType === 0 || stor.invsType === 1 ? (null) : (
                                (uiElement.DeleIcon === true ? (
                                    <div className={clasCAB.wrapperCAB}>
                                        {permistionInv.De ? (
                                            <Fab
                                                size="medium"
                                                color="primary"
                                                // disabled
                                                style={{ ...style.iconBtn, ...stElemnt.all.iconBtn }}
                                                className={buttonClassnameDelete}
                                                onClick={(e) => {
                                                    setConfirmDialog({
                                                        isOpen: true,
                                                        onConfirm: () => {
                                                            deleteTos(e);

                                                        },
                                                    })
                                                }}
                                            >
                                                {success.delete ? <CheckIcon /> : <DeleteIcon />}
                                            </Fab>
                                        ) : (
                                            //   <Fragment>{elmntIcon(<DeleteIcon />, true)}</Fragment>
                                            <Fab
                                                size="medium"
                                                color="primary"
                                                disabled={true}
                                                style={{ ...style.iconBtn, ...stElemnt.all.iconBtn }}
                                            >
                                                <DeleteIcon />
                                            </Fab>
                                        )}
                                        {loading.delete && (
                                            <CircularProgress
                                                size={56}
                                                className={clasCAB.fabProgressCAB}
                                            />
                                        )}
                                    </div>
                                ) : null)
                            )
                        }

                        {(setting.PrTy_InPr != "03" && setting.PrTy_InPr != "04")
                            && or.postput == "toPut" && !isHedden
                            &&
                            (
                                <div className={clasCAB.wrapperCAB}>
                                    <Fab
                                        size="medium"
                                        color="primary"
                                        style={{ ...style.iconBtn, ...stElemnt.all.iconBtn }}
                                        onClick={(event) => clickUpdate()}

                                        disabled={
                                            or.postput == "toPost"
                                                ? isSave === false ? true : false
                                                : loading.print || loading.save
                                        }
                                    >
                                        <Update />
                                    </Fab>
                                </div>
                            )}

                        <div className={clasCAB.wrapperCAB}>
                            <Fab
                                size="medium"
                                color="primary"
                                style={{ ...style.iconBtn, ...stElemnt.all.iconBtn }}
                                onClick={(event) => clickOpenTogglePrint(event)}
                                disabled={
                                    or.postput == "toPost"
                                        ? !isSave ? true : isLoading :
                                        isLoading
                                }

                            >
                                <PrintIcon />
                            </Fab>
                        </div>
                        <div className={clasCAB.wrapperCAB}>
                            <Fab
                                size="medium"
                                color="primary"
                                disabled={or.postput == "toPut" && !isOpenUpdate ? true :
                                    or.postput == "toPost"
                                        ? !isSave ? true : isLoading :
                                        isLoading
                                }
                                style={{ ...style.iconBtn, ...stElemnt.all.iconBtn }}
                                className={buttonClassnameSave}
                                onClick={() => toWhere("save", "e")}
                            >
                                {" "}
                                {success.save ? <CheckIcon /> : <SaveIcon />}
                            </Fab>

                            {(loading.print || loading.save) && (
                                <CircularProgress
                                    size={56}
                                    className={clasCAB.fabProgressCAB}
                                />
                            )}
                        </div>
                        {stor.invsType == 2 && or.postput !== "toPost" ? (
                            <div className={clasCAB.wrapperCAB}>
                                <Fab
                                    size="medium"
                                    color="primary"
                                    style={{ ...style.iconBtn, ...stElemnt.all.iconBtn }}
                                    onClick={transformDone}
                                >
                                    {" "}
                                    <TransformIcon />
                                </Fab>
                            </div>
                        ) : null}
                        {stor.invsType == 6 && or.postput != "toPost" ? (
                            <div className={clasCAB.wrapperCAB}>
                                <Fab
                                    size="medium"
                                    color="primary"
                                    style={{ ...style.iconBtn, ...stElemnt.all.iconBtn }}
                                    onClick={transformDonePurch}
                                >
                                    {" "}
                                    <TransformIcon />
                                </Fab>
                            </div>
                        ) : null}
                    </Hidden>


                    <Hidden only={["xs"]}>
                        {stor.invsType === 0 || stor.invsType === 1 ? (null) :
                            (
                                (uiElement.DeleIcon === true ? (
                                    <Fragment>
                                        <div className={clasCAB.wrapperCAB}>
                                            {/* {!permiElm.De ? ( */}
                                            {permistionInv.De ? (
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    size="large"
                                                    className={buttonClassnameDelete}
                                                    startIcon={<DeleteIcon />}
                                                    style={{ ...style.iconBtn, ...stElemnt.all.iconBtn }}
                                                    onClick={(e) => {
                                                        setConfirmDialog({
                                                            isOpen: true,
                                                            onConfirm: () => {
                                                                deleteTos(e);
                                                            },
                                                        })
                                                    }}
                                                >
                                                    {transForm("delete")}
                                                </Button>
                                            ) : (
                                                //   <Fragment>{elmntBtn("حـذف", <DeleteIcon />)}</Fragment>
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    size="large"
                                                    style={{ ...style.iconBtn, ...stElemnt.all.iconBtn }}
                                                    disabled={true}
                                                    startIcon={<DeleteIcon />}
                                                >
                                                    {" "}
                                                    {transForm("delete")}
                                                </Button>
                                            )}
                                            {loading.delete && (
                                                <CircularProgress
                                                    size={24}
                                                    className={clasCAB.buttonProgressCAB}
                                                />
                                            )}
                                        </div>
                                    </Fragment>
                                ) : null)

                            )}


                        {stor.invsType == 2 && or.postput != "toPost" ? (
                            <div className={clasCAB.wrapperCAB}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    size="large"
                                    startIcon={<TransformIcon />}
                                    style={{ ...style.iconBtn, ...stElemnt.all.iconBtn }}
                                    onClick={transformDone}
                                >
                                    {transForm("change_to_sale_invoice")}
                                </Button>
                            </div>
                        ) : null}
                        {stor.invsType == 6 && or.postput != "toPost" ? (
                            <div className={clasCAB.wrapperCAB}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    size="large"
                                    startIcon={<TransformIcon />}
                                    style={{ ...style.iconBtn, ...stElemnt.all.iconBtn }}
                                    onClick={transformDonePurch}
                                >
                                    {transForm("change_to_purchase_invoice")}
                                </Button>
                            </div>
                        ) : null}
                        <div className={clasCAB.wrapperCAB}>
                            {permistionInv.Prv && permistionInv.SaUp ? (
                                <Fab
                                    size="medium"
                                    color="primary"
                                    style={{ ...style.iconBtn, ...stElemnt.all.iconBtn }}
                                    onClick={(e) => clickOpenToggle(e, 2)}
                                >
                                    <MoreVert />
                                </Fab>
                            ) : (
                                <Fab
                                    size="medium"
                                    color="primary"
                                    disabled={true}
                                    style={{ ...style.iconBtn, ...stElemnt.all.iconBtn }}
                                >
                                    <MoreVert />
                                </Fab>
                            )}
                        </div>
                        {or.postput == "toPut" && !isHedden && (
                            <div className={clasCAB.wrapperCAB}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    size="large"
                                    className={buttonClassnamePrint}
                                    startIcon={<Update />}
                                    style={{ ...style.iconBtn, ...stElemnt.all.iconBtn }}
                                    disabled={isOpenUpdate ? true :
                                        or.postput == "toPost"
                                            ? isSave === false ? true : false
                                            : loading.print || loading.save
                                    }
                                    onClick={() => clickUpdate()}
                                >
                                    {transForm("update")}
                                </Button>
                                {(loading.print || loading.save) && (
                                    <CircularProgress
                                        size={24}
                                        className={clasCAB.buttonProgressCAB}
                                    />
                                )}
                            </div>
                        )}
                        <div className={clasCAB.wrapperCAB}>
                            <Button
                                variant="contained"
                                color="primary"
                                size="large"
                                style={{ ...style.iconBtn, ...stElemnt.all.iconBtn }}
                                className={buttonClassnameSave}
                                disabled={
                                    or.postput == "toPost"
                                        ? !isSave ? true : isLoading :
                                        isLoading
                                }
                                onClick={() => toPrint("print", "e", 2)}
                                startIcon={<ScannerIcon />}
                            >
                            {"F11 "}{transForm("great-view")}
                            </Button>

                            {(loading.print || loading.save) && (
                                <CircularProgress
                                    size={24}
                                    className={clasCAB.buttonProgressCAB}
                                />
                            )}
                        </div>

                        <div className={clasCAB.wrapperCAB}>
                            <Button
                                variant="contained"
                                color="primary"
                                size="large"
                                className={buttonClassnamePrint}
                                startIcon={<PrintIcon />}
                                style={{ ...style.iconBtn, ...stElemnt.all.iconBtn }}
                                disabled={
                                    or.postput == "toPost"
                                        ? !isSave ? true : isLoading :
                                        isLoading
                                }
                                onClick={() => toPrint("print", "e", 1)}
                            >
                               {"F3 "} {transForm("cashier-view")}
                            </Button>
                            {(loading.print || loading.save) && (
                                <CircularProgress
                                    size={24}
                                    className={clasCAB.buttonProgressCAB}
                                />
                            )}
                        </div>
                        <div className={clasCAB.wrapperCAB} >
                            <Button
                                variant="contained"
                                color="primary"
                                size="large"
                                style={{ ...style.iconBtn, ...stElemnt.all.iconBtn }}
                                className={buttonClassnameSave}
                                disabled={or.postput == "toPut" && !isOpenUpdate ? true :
                                    or.postput == "toPost"
                                        ? !isSave ? true : isLoading :
                                        isLoading
                                }
                                onClick={() => toWhere("save", "e")}
                                startIcon={<SaveIcon />}

                            >
                                {"F10 "}{transForm("save-out-print")}
                            </Button>
                            {(loading.print || loading.save) && (
                                <CircularProgress
                                    size={24}
                                    className={clasCAB.buttonProgressCAB}
                                />
                            )}
                        </div>


                    </Hidden>
                </Toolbar>
            </AppBar>
        </React.Fragment>
    );
}